module.exports = __webpack_public_path__ + "assets/img/live33.f7e6de2e.png";